import { render } from "./WCToastHeader.vue?vue&type=template&id=ac739aa2"
import script from "./WCToastHeader.vue?vue&type=script&lang=js"
export * from "./WCToastHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__